
import React, { useState } from 'react'
import { Button, Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import { SearchOutlined } from "@mui/icons-material";
import HttpsSharpIcon from '@mui/icons-material/HttpsSharp';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import AddSharpIcon from '@mui/icons-material/AddSharp';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import LoopSharpIcon from '@mui/icons-material/LoopSharp';
import DownloadSharpIcon from '@mui/icons-material/DownloadSharp';
const manageapp = [
    {
        name: "Design Engineer",
        job: "Quality Engineer",
        day: "day left",
        company: "Shivam Electricals Pvt Ltd",
        applyDate: "Sep 28, 2023",
        avatar: "https://via.placeholder.com/50",
    },
    {
        name: "Design Engineer",
        job: "Quality Engineer",
        day: "day left",
        company: "Shivam Electricals Pvt Ltd",
        applyDate: "Sep 28, 2023",
        avatar: "https://via.placeholder.com/50",
    },
    {
        name: "Design Engineer",
        job: "Quality Engineer",
        day: "day left",
        company: "Shivam Electricals Pvt Ltd",
        applyDate: "Sep 28, 2023",
        avatar: "https://via.placeholder.com/50",
    },
    {
        name: "Design Engineer",
        job: "Quality Engineer",
        day: "day left",
        company: "Shivam Electricals Pvt Ltd",
        applyDate: "Sep 28, 2023",
        avatar: "https://via.placeholder.com/50",
    },
    {
        name: "Design Engineer",
        job: "Quality Engineer",
        day: "day left",
        company: "Shivam Electricals Pvt Ltd",
        applyDate: "Sep 28, 2023",
        avatar: "https://via.placeholder.com/50",
    },

];


const AlertCandidateList = () => {

    return (
        <>

            <section className="pricing-section-three container jobapplication   pt-5">
                <div className="row">
                    <div className="mb-1 col-6">
                        <h6 className="orange-title">
                            <span className="orange-box me-2"></span>
                            Alert Candidates </h6>
                    </div>
                    <div className="mb-1 col-6 text-start">
                        {/* <h6 className="  d-flex justify-content-end">
                            <Link to={"/Interviews"}>
                                Interviews
                            </Link>
                        </h6> */}
                    </div>
                </div>
                <div className="container st3">
                    <div className="row">
                        <div className="col-lg-12">

                            <div class="wd-findjob-filer">
                                <div className="form-group-1 ps-1 khojSearch d-flex align-items-center mb-2">
                                    <SearchOutlined className="searchIcon" />
                                    <input
                                        type="text"
                                        className="input-filter-search"
                                        placeholder="Search"
                                    />
                                </div>
                                <div class="group-select">
                                    <div className="Dropdown-root react-dropdown sort sort-buy mb-2">
                                        <Dropdown>
                                            <Dropdown.Toggle as="div" className="Dropdown-control sort" aria-haspopup="listbox">
                                                <div className="Dropdown-placeholder is-selected">
                                                    Sort by Default...
                                                </div>
                                                <div className="Dropdown-arrow-wrapper">
                                                    <span className="Dropdown-arrow"></span>
                                                </div>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="#/action-1">View Job</Dropdown.Item>
                                                <Dropdown.Item href="#/action-2">Remove Job</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                            <div className="table-res">
                                <table className="notification-table">
                                    <thead>
                                        <tr>
                                            <th className="ps-5">Title</th>
                                            <th>Alert Query</th>
                                            <th>Number Candidate </th>
                                            {/* <th>Recent Works</th> */}
                                            <th>Times</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {manageapp.map((item, index) => (
                                            <tr key={index} className='table-tr'>
                                                <td>
                                                    <div className="candidate-info">
                                                        {/* <img
                                                            src={item.avatar}
                                                            alt="avatar"
                                                            className="avatar"
                                                        /> */}
                                                        <div className="row">
                                                            <span className="cmpnyname">{item.name}</span>
                                                            {/* <div className="mt-1">
                                                                <span className="company">
                                                                    <span class="icon-map-pin me-1"></span>
                                                                    {item.company}</span>
                                                                <span className="company ms-3">
                                                                    <span class="icon-calendar me-1"></span>
                                                                    {item.day}</span>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    Type: Full Time <br />
                                                    Applied Date: All <br />
                                                    Experience: 2 Years <br />
                                                    Career Level: Officer
                                                </td>
                                                <td>Candidate found 21</td>

                                                <td className="actions tableActions d-flex align-items-center">
                                                    Daily
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AlertCandidateList